import { createContext, useContext } from "react";

export type ShellContextValue = {
  query: string;
  setQuery: (q: string) => void;
};

export const ShellContext = createContext<ShellContextValue | null>(null);

export function useShell(): ShellContextValue {
  const ctx = useContext(ShellContext);
  if (!ctx) throw new Error("useShell must be used inside <AppShell>");
  return ctx;
}
